import { PureComponent } from "react";

import { BasicRecord } from "./basicRecord";
import { BasicTable } from "./BasicTable";
import { SummaryResultNetworkType, SummaryResultType } from "./enumerations";

interface AddressProps {
  providersEndpointFunc: (networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: number) => string;
  records: BasicRecord[];
}

class Address extends PureComponent<AddressProps> {
  public render() {

    if (this.props.records.length === 0) {
      return (
        <div>No Provider Data Found</div>
      )
    } else {
      return (
        <BasicTable {...this.props} records={this.props.records} tableName="# of Addresses" />
      );
    }
  }
}

export { Address };
